import {
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Typography,
} from "@mui/material"
import { useAudioSettingsContext } from "contexts/AudioSettingsContext"
import { t } from "i18next"
import { useEffect, useRef } from "react"
import { styles } from "../Controllers.styles"

const speeds = [
  {
    value: 1,
    label: "x1",
  },
  {
    value: 0.9,
    label: "x0.9",
  },
  {
    value: 0.8,
    label: "x0.8",
  },
  {
    value: 0.7,
    label: "x0.7",
  },
]

export default function SpeedOptions({
  open,
  anchorRef,
  onClose = () => {
    console.log("onCloseSpeedOptions")
  },
  sx,
}) {
  const prevOpen = useRef(open)
  const { audioSettings, setAudioSettings } = useAudioSettingsContext()

  // return focus to the button when we transitioned from !open -> open
  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus()
    }
    prevOpen.current = open
  }, [open])

  const handleListKeyDown = (event) => {
    if (event.key === "Tab") {
      event.preventDefault()
      onClose()
    } else if (event.key === "Escape") {
      onClose()
    }
  }

  const onMenuClick = (speedSel) => {
    setAudioSettings({
      ...audioSettings,
      speed: speedSel.value,
      speedLabel: speedSel.label,
    })
    onClose()
  }

  return (
    <Popper
      open={open}
      anchorEl={anchorRef.current}
      role={undefined}
      placeholder="bottom-start"
      transition
      disablePortal
      sx={sx}
    >
      {({ TransitionProps, placement }) => (
        <Grow
          {...TransitionProps}
          style={{
            transformOrigin:
              placement === "bottom" ? "center top" : "center bottom",
          }}
        >
          <Paper sx={styles.controllerContainer}>
            <ClickAwayListener onClickAway={onClose}>
              <MenuList
                autoFocusItem={open}
                id="speed-options"
                aria-labelledby="speed-options-button"
                onKeyDown={handleListKeyDown}
              >
                <Typography fontWeight="bold">{t("audio_speed")}</Typography>
                {speeds.map((speed) => (
                  <MenuItem
                    key={speed.value}
                    onClick={(e) => {
                      e.stopPropagation()
                      onMenuClick(speed)
                    }}
                    selected={audioSettings?.speed === speed.value}
                  >
                    {speed.label}
                  </MenuItem>
                ))}
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  )
}
